"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHedgeGridTPSLParams = exports.useHedgeTPSLParams = exports.useHedgeTPSLParamsImp = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const interface_1 = require("../../../../interface");
const CalculateUtils_1 = require("../CalculateUtils");
const TPSLUtils_1 = require("./TPSLUtils");
const TradeTPSL_1 = require("./TradeTPSL");
const GridTradeTPSL_1 = require("./GridTradeTPSL");
/**过滤掉不必要的参数 */
function filterParams(params) {
    const { percent, triggerPrice, estPnl, latestPrice, priceType, latestPricePercent, closeMode, closeQty, triggerLimitPrice, checkLimit, } = params;
    return {
        percent,
        triggerPrice,
        estPnl,
        latestPrice,
        priceType,
        latestPricePercent,
        closeMode,
        closeQty,
        triggerLimitPrice,
        checkLimit,
    };
}
/**
 * 同时获取买卖两个方向的止盈止损参数，方便在下单时在两个方向上进行切换
 *
 * @returns 双方向的止盈止损参数 @see{TradeHedgeTPSLParams}
 *
 * 这样做也方便后续要同时显示两个方向的止盈止损，该hooks在内部调用两次`useTradeTPSLParams`，将传入的数据实时同步到这两个hooks中
 */
function useHedgeTPSLParamsImp(buyParams, sellParams) {
    const { resetParams: resetLongParams, changePrice: changeLongPrice, changePercent: changeLongPercent, setPriceType: setLongPriceType, createOrderTPSL: createBuy, createOrderTPSLWeb: createBuyWeb, setCloseMode: changeBuyCloseMode, setCloseQty: changeBuyCloseQty, showSlLiquidPriceWarning: showSlLiquidPriceWarningBuy, changeTriggerLimitPrice: changeTriggerLimitPriceLong, } = buyParams;
    const { resetParams: resetShortParams, changePrice: changeShortPrice, changePercent: changeShortPercent, setPriceType: setShortPriceType, createOrderTPSL: createSell, createOrderTPSLWeb: createSellWeb, setCloseMode: changeSellCloseMode, setCloseQty: changeSellCloseQty, showSlLiquidPriceWarning: showSlLiquidPriceWarningSell, changeTriggerLimitPrice: changeTriggerLimitPriceShort, } = sellParams;
    const validate = (0, react_1.useCallback)((side, estLiqPrice, ignoreInvalidPrice = true) => {
        const validateFn = side === interface_1.CustomOrderSide.BUY ? buyParams.validate : sellParams.validate;
        const errorInfo = validateFn(estLiqPrice);
        if (ignoreInvalidPrice) {
            return TPSLUtils_1.TPSLUtils.filterError(errorInfo);
        }
        return errorInfo;
    }, [buyParams.validate, sellParams.validate]);
    const validateWeb = (0, react_1.useCallback)((side, triggerPrice, estLiqPrice, triggerLimitPrice, ignoreInvalidPrice = true) => {
        const validateFn = side === interface_1.CustomOrderSide.BUY ? buyParams.validateUserInput : sellParams.validateUserInput;
        // 反向一下
        const orderSide = side === interface_1.CustomOrderSide.BUY ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY;
        const positionSide = CalculateUtils_1.CalculateUtils.getPositionSide(interface_1.OrderPositionMode.BUYSELL, true, orderSide);
        const errorInfo = validateFn(triggerPrice, positionSide, estLiqPrice, triggerLimitPrice);
        if (ignoreInvalidPrice) {
            return TPSLUtils_1.TPSLUtils.filterError(errorInfo);
        }
        return errorInfo;
    }, [buyParams.validateUserInput, sellParams.validateUserInput]);
    const showSlLiquidPriceWarning = (0, react_1.useCallback)((_a) => {
        var { side } = _a, params = __rest(_a, ["side"]);
        const fn = side === interface_1.CustomOrderSide.BUY ? showSlLiquidPriceWarningBuy : showSlLiquidPriceWarningSell;
        return fn(params);
    }, [showSlLiquidPriceWarningBuy, showSlLiquidPriceWarningSell]);
    const createTpSl = (0, react_1.useCallback)(({ side, orderId, estLiqPrice, triggerId }) => {
        if (!validate(side, estLiqPrice, false)) {
            // 不存在错误
            const createFn = side === interface_1.CustomOrderSide.BUY ? createBuy : createSell;
            return createFn({ orderId, triggerId });
        }
        return (0, rxjs_1.of)(null);
    }, [createBuy, createSell, validate]);
    const createTpSlWeb = (0, react_1.useCallback)((params) => {
        const { triggerPrice, side, estLiqPrice, triggerLimitPrice } = params;
        if (!validateWeb(side, triggerPrice, estLiqPrice, triggerLimitPrice)) {
            // 不存在错误
            const createFn = side === interface_1.CustomOrderSide.BUY ? createBuyWeb : createSellWeb;
            return createFn(params);
        }
        return (0, rxjs_1.of)(null);
    }, [createBuyWeb, createSellWeb, validateWeb]);
    const resetParams = (0, react_1.useCallback)(() => {
        resetLongParams();
        resetShortParams();
    }, [resetLongParams, resetShortParams]);
    const changePrice = (0, react_1.useCallback)((price) => {
        changeLongPrice(price);
        changeShortPrice(price);
    }, [changeLongPrice, changeShortPrice]);
    const changePercent = (0, react_1.useCallback)((p) => {
        changeLongPercent(p);
        changeShortPercent(p);
    }, [changeLongPercent, changeShortPercent]);
    const setPriceType = (0, react_1.useCallback)((type) => {
        setLongPriceType(type);
        setShortPriceType(type);
    }, [setLongPriceType, setShortPriceType]);
    const changeCloseMode = (0, react_1.useCallback)((mode) => {
        changeBuyCloseMode(mode);
        changeSellCloseMode(mode);
    }, [changeBuyCloseMode, changeSellCloseMode]);
    const changeCloseQty = (0, react_1.useCallback)((closeQty) => {
        changeBuyCloseQty(closeQty);
        changeSellCloseQty(closeQty);
    }, [changeBuyCloseQty, changeSellCloseQty]);
    const changeTriggerLimitPrice = (0, react_1.useCallback)((limitPrice = "") => {
        changeTriggerLimitPriceLong(limitPrice, true);
        changeTriggerLimitPriceShort(limitPrice, true);
    }, [changeTriggerLimitPriceLong, changeTriggerLimitPriceShort]);
    return {
        buyParams: filterParams(buyParams),
        sellParams: filterParams(sellParams),
        validate,
        createTpSl,
        changePrice,
        changePercent,
        setPriceType,
        showSlLiquidPriceWarning,
        triggerPrice: buyParams.triggerPrice,
        priceType: buyParams.priceType,
        resetParams,
        validateWeb,
        createTpSlWeb,
        closeMode: buyParams.closeMode,
        closeQty: buyParams.closeQty,
        changeCloseMode,
        changeCloseQty,
        triggerLimitPrice: buyParams.triggerLimitPrice,
        checkLimit: buyParams.checkLimit,
        changeTriggerLimitPrice,
    };
}
exports.useHedgeTPSLParamsImp = useHedgeTPSLParamsImp;
function useHedgeTPSLParams(props) {
    const buyParams = (0, TradeTPSL_1.useTradeTPSLParams)(Object.assign(Object.assign({}, props), { orderSide: interface_1.CustomOrderSide.BUY }));
    const sellParams = (0, TradeTPSL_1.useTradeTPSLParams)(Object.assign(Object.assign({}, props), { orderSide: interface_1.CustomOrderSide.SELL }));
    return useHedgeTPSLParamsImp(buyParams, sellParams);
}
exports.useHedgeTPSLParams = useHedgeTPSLParams;
function useHedgeGridTPSLParams(props) {
    const buyParams = (0, GridTradeTPSL_1.useGridTradeTPSLParams)(Object.assign(Object.assign({}, props), { orderSide: interface_1.CustomOrderSide.BUY }));
    const sellParams = (0, GridTradeTPSL_1.useGridTradeTPSLParams)(Object.assign(Object.assign({}, props), { orderSide: interface_1.CustomOrderSide.SELL }));
    return useHedgeTPSLParamsImp(buyParams, sellParams);
}
exports.useHedgeGridTPSLParams = useHedgeGridTPSLParams;
